var EventSubscription =
{
    submit: function(e)
    {
        e.preventDefault();

        var _form = $(event.target);
        var _container = _form.closest('[data-item="event-subscription-container"]');
        var _modal = $('.modal');
        var _submit = _form.find('input[type="submit"]');

        _submit.prop('disabled', 'disabled');

        $.ajax
        (
            {
                method: 'POST',
                url: _form.prop('action'),
                data: _form.serializeArray()
            }
        ).done
        (
            function(e)
            {
                _submit.prop('disabled', null);

                _modal.find('.modal-title').html(e.message.title);
                _modal.find('.modal-body').html(e.message.body);

                _modal.modal('show');
            }
        );
    },

    init: function()
    {
        $('[data-action="event-subscription"]').on('submit', EventSubscription.submit);
    }
};

$(EventSubscription.init);
